var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_508_10125)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 50.625C0 55.8028 4.19719 60 9.375 60H50.625C55.8028 60 60 55.8028 60 50.625V9.375C60 4.19719 55.8028 0 50.625 0H9.375C4.19719 0 0 4.19719 0 9.375V50.625Z",
    fill: "#BAD7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 50.625C0.000248596 53.1113 0.988049 55.4958 2.74615 57.2539C4.50425 59.012 6.88867 59.9998 9.375 60H26.25C28.7363 59.9998 31.1208 59.012 32.8789 57.2539C34.637 55.4958 35.6248 53.1113 35.625 50.625V33.75C35.6248 31.2637 34.637 28.8792 32.8789 27.1211C31.1208 25.363 28.7363 24.3752 26.25 24.375H9.375C6.88867 24.3752 4.50425 25.363 2.74615 27.1211C0.988049 28.8792 0.000248596 31.2637 0 33.75L0 50.625Z",
    fill: "#4B84DD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.0984 11.25L35.2365 22.1119C35.0574 22.2848 34.9146 22.4917 34.8163 22.7205C34.718 22.9493 34.6663 23.1953 34.6641 23.4442C34.662 23.6932 34.7094 23.9401 34.8037 24.1705C34.898 24.401 35.0372 24.6103 35.2132 24.7864C35.3893 24.9624 35.5986 25.1016 35.8291 25.1959C36.0595 25.2902 36.3064 25.3376 36.5554 25.3355C36.8043 25.3333 37.0504 25.2816 37.2791 25.1833C37.5079 25.0851 37.7148 24.9422 37.8877 24.7631L48.7496 13.9013V16.875C48.7496 17.3723 48.9471 17.8492 49.2988 18.2008C49.6504 18.5525 50.1273 18.75 50.6246 18.75C51.1219 18.75 51.5988 18.5525 51.9504 18.2008C52.3021 17.8492 52.4996 17.3723 52.4996 16.875V11.25C52.4996 10.2554 52.1045 9.30161 51.4013 8.59835C50.698 7.89509 49.7442 7.5 48.7496 7.5H43.1246C42.6273 7.5 42.1504 7.69754 41.7988 8.04918C41.4471 8.40081 41.2496 8.87772 41.2496 9.375C41.2496 9.87228 41.4471 10.3492 41.7988 10.7008C42.1504 11.0525 42.6273 11.25 43.1246 11.25H46.0984Z",
    fill: "#549BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_508_10125"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.feab6ace9fcd61caba4829505e27b547.svg";
export { ForwardRef as ReactComponent };